import { StyleSheet } from '@react-pdf/renderer';

// El contrato es un documento corrido, no un formato de casillas como el F – CR - 03:
// se usa Times y márgenes de carta jurídica en lugar de la retícula verde.
export const COLORS = {
    texto: '#000000',
    linea: '#000000',
    suave: '#5A5A5A',
    marca: '#C00000',
};

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Times-Roman',
        fontSize: 10,
        lineHeight: 1.4,
        color: COLORS.texto,
        paddingTop: 28,
        // El pie ocupa cuatro líneas más el paginado; con menos margen el texto
        // de la última cláusula de cada página se monta encima.
        paddingBottom: 64,
        paddingHorizontal: 56,
    },

    // ---- Encabezado ----
    header: {
        alignItems: 'center',
        marginBottom: 14,
    },
    logo: {
        width: 150,
    },
    tagline: {
        fontFamily: 'Times-Bold',
        fontSize: 7,
        color: COLORS.marca,
        marginTop: 2,
    },

    titulo: {
        fontFamily: 'Times-Bold',
        fontSize: 12,
        textAlign: 'center',
        marginBottom: 12,
    },

    // ---- Cuerpo ----
    parrafo: {
        textAlign: 'justify',
        marginBottom: 7,
    },
    clausulaTitulo: {
        fontFamily: 'Times-Bold',
        marginTop: 4,
        marginBottom: 4,
    },
    item: {
        textAlign: 'justify',
        marginBottom: 2,
        paddingLeft: 18,
    },
    cierre: {
        textAlign: 'justify',
        marginTop: 10,
        marginBottom: 6,
    },

    // ---- Firmas ----
    firmasRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 28,
    },
    firmaCol: {
        width: '46%',
    },
    firmaLinea: {
        borderTopWidth: 0.8,
        borderColor: COLORS.linea,
        paddingTop: 3,
    },
    firmaRol: {
        fontFamily: 'Times-Bold',
        fontSize: 9,
        marginBottom: 34,
    },
    firmaNombre: {
        fontFamily: 'Times-Bold',
        fontSize: 9,
    },
    firmaDato: {
        fontSize: 9,
    },

    // ---- Pie ----
    footer: {
        position: 'absolute',
        bottom: 18,
        left: 56,
        right: 56,
        textAlign: 'center',
        fontSize: 7,
        color: COLORS.suave,
        lineHeight: 1.3,
    },
    paginado: {
        position: 'absolute',
        bottom: 8,
        left: 56,
        right: 56,
        textAlign: 'center',
        fontSize: 7,
        color: COLORS.suave,
    },
});

export default styles;
